<template>
  <svg
    :width="size + 'px'"
    :height="size + 'px'"
    :viewBox="'0 0 ' + size + ' ' + size"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="check-group"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <circle
        id="filled-circle"
        :cx="center"
        :cy="center"
        :r="radius"
        fill="var(--color-green)"
      ></circle>
      <circle
        id="white-circle"
        :cx="center"
        :cy="center"
        :r="radius + 1"
        fill="#FFFFFF"
      ></circle>
      <circle
        id="outline"
        :cx="center"
        :cy="center"
        :r="radius"
        stroke="var(--color-green)"
        stroke-width="4"
      ></circle>
      <polyline
        id="check"
        :points="checkPoints"
        stroke="#FFFFFF"
        stroke-width="4"
      ></polyline>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'CheckAnimation',
  props: {
    size: {
      type: Number,
      default: 133,
    },
  },
  computed: {
    radius() {
      return this.size / 2 - 9; // Adjusting for stroke width
    },
    center() {
      return this.size / 2;
    },
    checkPoints() {
      const offset = this.size / 133;
      return `${41 * offset} ${70 * offset}, ${56 * offset} ${85 * offset}, ${92 * offset} ${49 * offset}`;
    },
  },
};
</script>

<style scoped>
@keyframes outline {
  from {
    stroke-dasharray: 0, calc(3.1416 * var(--radius) * 2);
  }
  to {
    stroke-dasharray: calc(3.1416 * var(--radius) * 2),
      calc(3.1416 * var(--radius) * 2);
  }
}

#outline {
  animation: 0.38s ease-in outline;
  transform: rotate(0deg);
  transform-origin: center;
}

@keyframes circle {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(0);
  }
}

#white-circle {
  animation: 0.35s ease-in 0.35s forwards circle;
  transform: none;
  transform-origin: center;
}

@keyframes check {
  from {
    stroke-dasharray: 0, 75;
  }
  to {
    stroke-dasharray: 75, 75;
  }
}

#check {
  animation: 0.34s cubic-bezier(0.65, 0, 1, 1) 0.8s forwards check;
  stroke-dasharray: 0, 75;
}

@keyframes check-group {
  from {
    transform: scale(1);
  }
  50% {
    transform: scale(1.09);
  }
  to {
    transform: scale(1);
  }
}

#check-group {
  animation: 0.32s ease-in-out 1.03s check-group;
  transform-origin: center;
}
</style>
